import React from 'react';
import PropTypes from 'prop-types';

// INPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';
import SelectListGroup from '../../../../../components/common/selectListGroup/SelectListGroup';
import CheckBoxGroup from '../../../../../components/common/checkBoxGroup/CheckBoxGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';
import sortAlphaUTL from '../../../../../utils/sortAlphaUTL';

const PersonalInformationChina = ({ 
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
  handleOcrFileUpload,
  handleOcrImage,
  handleToggleDotInNameCheckbox,
}) => {
  const {
    firstName,
    lastName,
    dateOfBirth,
    gender,
    errors,

    // OCR
    fileNames,

    isDotInFullName

  } = formState;

  const genderOptions = [
    { label: transUTL('translateDropdown.select'), value: '' },
    { label: transUTL('translateDropdown.gender.female'), value: 'Female' },
    { label: transUTL('translateDropdown.gender.male'), value: 'Male' },
    {
      label: transUTL('translateDropdown.gender.wontSpecify'),
      value: "X",
    },
  ].sort(sortAlphaUTL);

  // Dynamic style preparation
  const uploadDocImage = (handleOcrImage.isDocScanned ? {color:'rgba(0, 0, 0, 0.1)', border:' 0.1rem solid rgba(0, 0, 0, 0.1)'} 
                       : {color:'#59c16f', border:' 0.1rem solid #59c16f'})
  const uploadSelfieImage = (handleOcrImage.isBioAuth ? {color:'rgba(0, 0, 0, 0.1)', border:' 0.1rem solid rgba(0, 0, 0, 0.1)'} 
                          : {color:'#59c16f', border:' 0.1rem solid #59c16f'})

  const inputElements = [
    {
      belongsTo: [
        'China ID Verification',
        'China Phone Alt',
        'China Phone',
        'China Bank Card',
        'Watchlist AML',
        'China Passport Verification',
        'China Driver License'
      ],
      element: (
        <TextFieldGroup
          key="firstName"
          id="firstName"
          type="text"
          name="firstName"
          dataName="firstNameCN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.firstName')}
          value={firstName}
          placeholder={transUTL('translatePlaceholder.inputCN.firstName')}
          placeholderTrigger={isEmptyVAL(firstName) ? 'input-empty' : ''}
          error={errors.firstName}
          errorTrigger={errors.firstName ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
    
    {
      belongsTo: [
        'China ID Verification',
        'China Phone',
        'China Phone Alt',
        'China Bank Card',
        'Watchlist AML',
        'China Passport Verification',
        'China Driver License'
      ],
      element: (
        <TextFieldGroup
          key="lastName"
          id="lastName"
          type="text"
          name="lastName"
          dataName="lastNameCN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.lastName')}
          value={lastName}
          placeholder={transUTL('translatePlaceholder.inputCN.lastName')}
          placeholderTrigger={isEmptyVAL(lastName) ? 'input-empty' : ''}
          error={errors.lastName}
          errorTrigger={errors.lastName ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },

    {
      belongsTo: [
        'China ID Verification',
        'China Phone Alt',
        'China Phone',
        'China Bank Card',
        'Watchlist AML',
        'China Passport Verification',
        'China Driver License'
      ],
      element: (
        <TextFieldGroup
          key="dateOfBirth"
          id="dateOfBirth"
          type="date"
          name="dateOfBirth"
          dataName="dateOfBirthCN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.dateOfBirth')}
          value={dateOfBirth}
          placeholder={transUTL('translatePlaceholder.inputCN.dateOfBirth')}
          max="9999-12-31"
          placeholderTrigger={isEmptyVAL(dateOfBirth) ? 'input-empty' : ''}
          error={errors.dateOfBirth}
          errorTrigger={errors.dateOfBirth ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },

    {
      belongsTo: [
        'China Passport Verification' 
      ],
      element: (
        <CheckBoxGroup // toggle adding '.' into 'fullName' if there is any in user's name, in case Api required
          key="isDotInFullName"
          checkboxBool={isDotInFullName}
          label={transUTL('translateFormOverview.isDotInFullName')}
          handleToggleCheckbox={handleToggleDotInNameCheckbox}
        />
      ),
    },
    
    {
      belongsTo: ['Watchlist AML'],
      element: (
        <SelectListGroup
          key="gender"
          id="gender"
          name="gender"
          dataName="genderCN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.gender')}
          value={gender}
          placeholderTrigger={isEmptyVAL(gender) ? 'input-empty' : ''}
          options={genderOptions}
          error={errors.gender}
          errorTrigger={errors.gender ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
    {
      belongsTo: [
        'China ID Verification',
        'China Phone Alt',
        'China Phone',
        'China Bank Card',
        'Watchlist AML',
        'China Passport Verification',
        'China Driver License'
      ],
      element: (
        <div key="document" className="ocr__form-btn">
          <p>{transUTL('translateBiometrics.docUpload')}</p>
          <div className="fileUpload ocr-btn" style={uploadDocImage}>
            <span>
              {!isEmptyVAL(fileNames.file1)
                ? `${fileNames.file1} ${transUTL(
                  'translateBiometrics.uploaded'
                )}`
                : `${transUTL('translateBiometrics.noFiles')}`}
            </span>
            {handleOcrImage.isDocScanned ? <input className="file-input-disable"/> :
            <input
              type="file"
              className="file-input"
              name="documentIMG"
              onChange={handleOcrFileUpload} 
              onBlur={handleOnBlur}
            /> 
            }
          </div>
        </div>
      ),
    },
    {
      belongsTo: [
        'China ID Verification',
        'China Phone Alt',
        'China Phone',
        'China Bank Card',
        'Watchlist AML',
        'China Passport Verification',
        'China Driver License'
      ],
      element: (
        <div key="selfie" className="ocr__form-btn">
          <p>{transUTL('translateBiometrics.selfieUpload')}</p>
          <div className="fileUpload ocr-btn" style={uploadSelfieImage}>
            <span>
              {!isEmptyVAL(fileNames.file2)
                ? `${fileNames.file2} ${transUTL(
                  'translateBiometrics.uploaded'
                )}`
                : `${transUTL('translateBiometrics.noFiles')}`}
            </span>
            {handleOcrImage.isBioAuth ? <input className="file-input-disable"/> :
            <input
              type="file"
              className="file-input"
              name="selfieIMG"
              onChange={handleOcrFileUpload}
              onBlur={handleOnBlur}
            />
            }
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

PersonalInformationChina.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
  handleOcrFileUpload: PropTypes.func.isRequired,
  handleOcrImage: PropTypes.object.isRequired,
  handleToggleDotInNameCheckbox: PropTypes.func.isRequired,
  isDotInFullName: PropTypes.bool.isRequired,
};

export default PersonalInformationChina;
